import React, { Component } from "react";

export class TitleText extends Component {
    render() {
        return <p className="title=text" {...this.props} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/Utils/TitleText.js